<template>
  <form @submit.prevent="addRawMat">
    <InputDash
      label="Serie"
      name="serie"
      :isTextArea="false"
      value="Auto"
      :isDisabled="true"
    />
    <InputDash
      label="REF Number"
      name="ref"
      :isTextArea="false"
      placeholder="Ref"
      :isDisabled="false"
      v-model="ref"
      :validation="!this.inValidFields.includes('ref')"
    />
    <InputDash
      label="Diameter"
      name="diameter"
      toggleProp="Thickness"
      :toggled="isThickness"
      @toggle="toggleThickness"
      :isTextArea="false"
      placeholder="Diameter"
      :isDisabled="false"
      v-model="diameter"
      :validation.sync="!this.inValidFields.includes('diameter')"
    />
    <InputDash
      label="Description"
      name="description"
      :isTextArea="true"
      placeholder="Description"
      :isDisabled="false"
      v-model="description"
      :validation="!this.inValidFields.includes('description')"
    />
    <div class="buttons">
      <BaseButton
        color="tertiary"
        :key="1"
        type="button"
        size="modal-sm"
        @click.native="emitClose(true)"
      >
        Cancel
      </BaseButton>
      <BaseButton color="primary" :key="2" type="submit" size="modal-sm">
        Add
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button.vue";
import InputDash from "@/components/base/InputDash.vue";

export default {
  components: {
    InputDash,
    BaseButton,
  },
  props: {
    title: String,
  },
  data() {
    return {
      ref: "",
      diameter: "",
      description: "",
      comment: "",
      isThickness: false,
      inValidFields: [],
    };
  },
  methods: {
    addRawMat: function() {
      this.inValidFields = [];

      var nmberRegEx = /^[0-9]{1,}(([\.\,]{0,1}[0-9]{1,})|([0-9]{0,}))$/;
      var diamIsValid = nmberRegEx.test(this.diameter);

      if (this.ref == "") {
        this.inValidFields.push("ref");
      }
      if (this.diameter == "" || diamIsValid == false) {
        this.inValidFields.push("diameter");
      }
      if (this.description == "") {
        this.inValidFields.push("description");
      }

      var that = this;

      if (this.inValidFields.length == 0) {
        this.$http
          .post(this.$endpoint + "management/rawmaterials/create", {
            ref: ref.value,
            diameter: diameter.value,
            description: description.value,
            isThickness: this.isThickness,
            comment: "",
          })
          .then(function(response) {
            that.$emit("closeModal", true);
            that.$swal(
              "Raw material added!",
              `Your raw material has been successfully added.`,
              "success"
            );
          })
          .catch(function(error) {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          });
      }
    },
    checkTypes() {},
    emitClose(isClicked) {
      this.$emit("closeModal", isClicked);
    },
    toggleThickness() {
      this.isThickness = !this.isThickness;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
</style>
